export { START, START_TOUCH, TOUCH, END } from '../src/NavdexPointType';
export type { NavdexPointType } from '../src/NavdexPointType';
